export default __webpack_public_path__ + "static/media/D2022_05_26_Ostia_Palpita_3.98cdb5e1.jpg";